<template>
    <div class="notification-perfection-reset">
        <span class="notification-perfection-reset__icon"></span>
        <div class="notification-perfection-reset-content">
            <span class="notification-perfection-reset__heading">KUSURSUZLUK</span>
            <span class="notification-perfection-reset__text">Doğruluk serin sıfırlandı.</span>
        </div>
        <div class="notification-perfection-reset-stats">
            <div class="notification-perfection-reset-data">
                <span class="notification-perfection-reset-data__value">{{ valueCurrent }}</span>
                <span class="notification-perfection-reset-data__icon"></span>
            </div>
            <div class="notification-perfection-reset-data">
                <span class="notification-perfection-reset-data__value">{{ valuePrevious }}</span>
                <span class="notification-perfection-reset-data__icon"></span>
            </div>
            <span class="notification-perfection-reset-data__progressbar"></span>
            <span class="notification-perfection-reset-data__art-direction"></span>
        </div>
        <svg class="notification-perfection-reset__art-perfection-x" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity=".53" clip-path="url(#clip0_1616_154)"><path d="M6.364 3.536L3.536 6.364 7.07 9.899l-3.535 3.536 2.828 2.829 3.535-3.536 3.536 3.536 2.829-2.829-3.536-3.536 3.536-3.535-2.829-2.828L9.899 7.07 6.364 3.536z" fill="#E86163"/></g><defs><clipPath id="clip0_1616_154"><path fill="#fff" transform="rotate(-45 11.95 4.95)" d="M0 0h14v14H0z"/></clipPath></defs></svg>
        <svg class="notification-perfection-reset__art-perfection-x" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity=".53" clip-path="url(#clip0_1616_154)"><path d="M6.364 3.536L3.536 6.364 7.07 9.899l-3.535 3.536 2.828 2.829 3.535-3.536 3.536 3.536 2.829-2.829-3.536-3.536 3.536-3.535-2.829-2.828L9.899 7.07 6.364 3.536z" fill="#E86163"/></g><defs><clipPath id="clip0_1616_154"><path fill="#fff" transform="rotate(-45 11.95 4.95)" d="M0 0h14v14H0z"/></clipPath></defs></svg>
    </div>
</template>
<script>
    export default {
        computed: {
            valuePrevious(){
                if(!this.$store.state.perfectionData){
                    return '';
                }
                return this.$store.state.perfectionData.previous;
            },
            valueCurrent(){
                if(!this.$store.state.perfectionData){
                    return '';
                }
                return this.$store.state.perfectionData.current;
            }
        }
    };
</script>
<style scoped src="@/css/components/notification-perfection-reset.css"></style>